import input from '../../../../input';

const custom = (params) => input.borderColor.disabled.custom(params);

export default custom;
